$(window).scroll(function () {
  scrollEvent();
  return this;
});

function scrollEvent() {
  let $root,scrollY;
  $root = $(document.documentElement);
  scrollY = $(this).scrollTop();
  if (scrollY > $(window).height()/2) {
    $root.attr('data-scrolled', true);
  } else {
    $root.attr('data-scrolled', false);
  }
};

